import { SectionCard } from "@/components/common/SectionCard";
import { ghostBtnClass } from "./serviceShared";
import type { ServiceResourceAlertRow } from "./useServiceResourceNotesSummary";

export function ServiceResourceAlertsPanel(props: {
  open: boolean;
  onClose: () => void;
  alerts: ServiceResourceAlertRow[];
  onDismiss: (noteId: string) => void;
  dismissBusy?: boolean;
}) {
  if (!props.open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/40 p-4 pt-16">
      <div className="w-full max-w-lg">
        <SectionCard
          title="Resource alerts"
          rightSlot={
            <button type="button" className={ghostBtnClass} onClick={props.onClose}>
              Close
            </button>
          }
        >
          {props.alerts.length === 0 ? (
            <p className="text-sm text-gray-600 dark:text-zinc-400">No active alerts.</p>
          ) : (
            <ul className="divide-y divide-gray-100 dark:divide-zinc-800">
              {props.alerts.map(({ note, resourceLabel }) => (
                <li key={note.id} className="flex flex-wrap items-start justify-between gap-2 py-3">
                  <div>
                    <div className="text-sm font-medium text-gray-900 dark:text-zinc-100">{resourceLabel}</div>
                    <p className="mt-1 text-sm text-gray-700 dark:text-zinc-300">{note.body}</p>
                    {note.expires_on ? (
                      <p className="mt-1 text-xs text-gray-500 dark:text-zinc-400">
                        Expires {note.expires_on}
                      </p>
                    ) : (
                      <p className="mt-1 text-xs text-gray-500 dark:text-zinc-400">No expiration — dismiss when resolved</p>
                    )}
                  </div>
                  <button
                    type="button"
                    className={`${ghostBtnClass} shrink-0 text-xs`}
                    disabled={props.dismissBusy}
                    onClick={() => props.onDismiss(note.id)}
                  >
                    Dismiss
                  </button>
                </li>
              ))}
            </ul>
          )}
        </SectionCard>
      </div>
    </div>
  );
}
